import React from "react";

const ShoppingCartRouter = () => {
  return (
    <div className="mt-4">
      <p>
        Home <span className="text-secondaryBlue text-lg">›</span> Cart
      </p>
    </div>
  );
};

export default ShoppingCartRouter;
